import { Injectable, signal } from '@angular/core';
import { InputComponent } from '@sanopass-frontend/design-system';
import { lastValueFrom, timer } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UIService {
  inProgress = signal<boolean>(false);
  isRefreshed = signal<boolean>(false);

  constructor() {}

  freeze(): void {
    //console.log('FREEZE');
    this.inProgress.set(true);
  }

  async unFreeze(): Promise<void> {
    await lastValueFrom(timer(500));
    this.inProgress.set(false);
  }

  async focusInput(input: InputComponent, timeout: number = 1) {
    await lastValueFrom(timer(timeout));
    input.focus();
  }

  refresh() {
    this.isRefreshed.update((value) => !value);

    timer(500).subscribe(() => {
      this.isRefreshed.update((value) => !value);
    });
  }
}
